/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateInstallmentsRequest } from '../models/CreateInstallmentsRequest';
import type { CreateMakePaymentRequest } from '../models/CreateMakePaymentRequest';
import type { CreatePrepareNextPaymentRequest } from '../models/CreatePrepareNextPaymentRequest';
import type { InstallmentOption } from '../models/InstallmentOption';
import type { InstallmentResult } from '../models/InstallmentResult';
import type { OpenApiInteger } from '../models/OpenApiInteger';
import type { Order } from '../models/Order';
import type { PaymentMethodResult } from '../models/PaymentMethodResult';
import type { PaymentPreview } from '../models/PaymentPreview';
import type { PaymentResult } from '../models/PaymentResult';
import type { RegistrationConfirmationResponse } from '../models/RegistrationConfirmationResponse';
import type { UpdateOrderRequest } from '../models/UpdateOrderRequest';
import type { UpdatePaymentMethodRequest } from '../models/UpdatePaymentMethodRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrdersService {

    /**
     * @param id
     * @returns Order The order
     * @throws ApiError
     */
    public static showOrder(
        id: OpenApiInteger,
    ): CancelablePromise<Order> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @param keepExistingInstallmentPlan
     * @returns Order The updated order
     * @throws ApiError
     */
    public static updateOrder(
        id: OpenApiInteger,
        requestBody: UpdateOrderRequest,
        keepExistingInstallmentPlan?: boolean,
    ): CancelablePromise<Order> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/orders/{id}',
            path: {
                'id': id,
            },
            query: {
                'keep_existing_installment_plan': keepExistingInstallmentPlan,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns PaymentResult Payment Result
     * @throws ApiError
     */
    public static makePayment(
        requestBody: CreateMakePaymentRequest,
    ): CancelablePromise<PaymentResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/orders/make-payment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns PaymentPreview PaymentPreview
     * @throws ApiError
     */
    public static prepareNextPayment(
        requestBody: CreatePrepareNextPaymentRequest,
    ): CancelablePromise<PaymentPreview> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/orders/prepare-next-payment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns PaymentMethodResult PaymentMethodResult
     * @throws ApiError
     */
    public static updatePaymentMethod(
        id: number,
        requestBody: UpdatePaymentMethodRequest,
    ): CancelablePromise<PaymentMethodResult> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/orders/{id}/update-payment-method',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns InstallmentResult List of InstallmentResults
     * @throws ApiError
     */
    public static createInstallments(
        id: OpenApiInteger,
        requestBody: CreateInstallmentsRequest,
    ): CancelablePromise<Array<InstallmentResult>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/orders/{id}/installments',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @returns Order Order
     * @throws ApiError
     */
    public static offlineCheckout(
        id: OpenApiInteger,
    ): CancelablePromise<Order> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/orders/{id}/offline-checkout',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @returns InstallmentOption List of InstallmentOptions
     * @throws ApiError
     */
    public static previewInstallmentPlanOptions(
        id: OpenApiInteger,
    ): CancelablePromise<Array<InstallmentOption>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/{id}/preview-installment-plan-options',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @param formId
     * @returns RegistrationConfirmationResponse RegistrationConfirmationResponseInterface
     * @throws ApiError
     */
    public static registrationConfirmation(
        id: OpenApiInteger,
        formId: OpenApiInteger,
    ): CancelablePromise<RegistrationConfirmationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/{id}/registration-confirmation/{formId}',
            path: {
                'id': id,
                'formId': formId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

}
